import * as React from "react";

const SvgComponent = ({ fill = "#000", stroke = "#636F7C", ...props }) => (
    <span>
  <svg
    width={30}
    height={30}
    fill={props.color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x={0.5} y={0.5} width={29} height={29} rx={5.5} stroke={stroke} />
    <path
      opacity={1}
      d="M15.44 8.24c3.877 0 7 3.124 7 7 0 3.877-3.123 7-7 7-3.876 0-7-3.123-7-7 0-3.876 3.162-7 7-7Zm.979 10.387a.996.996 0 0 0-.979-.978c-.526 0-.978.451-.94.978 0 .527.451.941.978.941.527.038.94-.414.94-.94Zm-1.844-7.225c-.075.15-.075.338-.075.489.037.489.075.978.075 1.43l.113 2.258c0 .226.037.451.037.715 0 .414.339.715.716.715.376 0 .715-.3.715-.677.075-1.167.113-2.333.188-3.5 0-.301.037-.64.075-.94a.95.95 0 0 0-.715-1.017c-.452-.113-.941.113-1.13.527Z"
      fill={fill}
    />
  </svg>
  </span>
);

export default SvgComponent;